import * as S from "./TabList.style";
import { TabItem } from "@/components/atoms/TabItem";

interface TabListProps {
  data?: any;
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const TabList = ({ data, activeTab, onTabChange }: TabListProps) => {
  return (
    <S.TabList $length={data.length}>
      {data.map((item: any, idx: number) => {
        return (
          <TabItem
            key={idx}
            data={item}
            onClick={() => onTabChange(item.id)}
            currentTab={activeTab}
          />
        );
      })}
    </S.TabList>
  );
};
